import {defineFormKitConfig} from '@formkit/vue'
import type {FormKitNode} from '@formkit/core'
import {createProPlugin, autocomplete, datepicker, togglebuttons, mask} from '@formkit/pro'
import {genesisIcons} from '@formkit/icons'
import {rootClasses} from './formkit.theme'
import {es, en} from '@formkit/i18n'

// Appends a red asterisk to the label of any input with a `required` or
// `accepted` validation rule, so users can see which fields are mandatory.
const requiredAsteriskPlugin = (node: FormKitNode) => {
    node.on('created', () => {
        const isRequired = node.props.parsedRules?.some(
            (rule: {name: string}) => rule.name === 'required' || rule.name === 'accepted'
        )
        if (!isRequired) return

        // Bust the schema memo cache for required nodes so they get their own
        // compiled schema separate from non-required inputs of the same type.
        if (
            typeof node.props.definition?.schemaMemoKey === 'string' &&
            !node.props.definition.schemaMemoKey.endsWith('-required')
        ) {
            node.props.definition.schemaMemoKey += '-required'
        }

        const originalSchema = node.props.definition!.schema
        node.props.definition!.schema = (extensions: Record<string, any> = {}) => {
            extensions.label = {
                children: [
                    '$label',
                    {
                        $el: 'span',
                        attrs: {class: 'text-red-500 ml-0.5'},
                        children: ['*'],
                    },
                ],
            }
            return (originalSchema as (e?: Record<string, any>) => any)(extensions)
        }
    })
}

export default defineFormKitConfig(() => {


    const pro = createProPlugin('fk-951603113f', {autocomplete, datepicker, togglebuttons, mask})

    return {
        plugins: [pro, requiredAsteriskPlugin],
        icons: genesisIcons,

        config: {
            rootClasses,
            locales: {en, es},
        },
    }
})
